import type { GetBasicReferralInfoResult, SuccessResult } from 'hydra-data-types';

/* use referralId selector to query validated referral-id rather than query string value (which may not exist in hcp_referrals) */
export type ReferralState = Omit<GetBasicReferralInfoResult, keyof SuccessResult> & {
  loading: boolean;
  error: string | undefined;
};

export const INITIAL_REFERRAL_STATE: ReferralState = {
  referralId: undefined,
  exists: false,
  hasUserId: false,
  hasAccessCode: false,
  isAslReferral: false,
  isWearableProvided: false,
  isPapReferral: false,
  loading: false,
  error: undefined,
};
